<template>
    <v-card v-if="model.id" class="elevation-2">
      <v-card-title class="text-h5">
        <h2 class="font-weight-bold text--primary"> Solicitudes De Alta </h2>
      </v-card-title>
      <v-card-subtitle class="title text--black font-weight-black font-weight-bold">
          {{`[ ${model.folio} ]`}}
      </v-card-subtitle>
      <v-tabs v-model="tab" background-color="primary" align-with-title dark>
        <v-tabs-slider color="white"></v-tabs-slider>
        <v-tab href="#General">General</v-tab>
        <v-tab href="#Movimientos" @click="viewMovs(model.folio)">Bitácora de Movimientos</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
          <!-- General -->
          <v-tab-item value="General">
            <v-card width="auto" outlined>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" sm="12" md="4" class="cuadro2">
                      <label class="font-weight-bold subtitle-1 text--primary"> Folio Factura </label>
                      <p class="font-weight-bold text--secondary">
                        {{model.factura.folio}}
                      </p>
                    </v-col>

                    <v-col cols="6" sm="3" md="3">
                      <label class="font-weight-bold subtitle-1 text--primary">Tipo de Actividad: </label>
                      <p class="font-weight-bold text--secondary">
                        <v-chip class="my-1" outlined label color="blue darken-3">
                          {{model.actividad.nombre}}
                        </v-chip>
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="successAction"/>
                    </v-col>
                  </v-row>
                </v-card-text>
          </v-card>
          </v-tab-item>

          <!-- Bitacorra -->
          <v-tab-item value="Movimientos">
            <v-card width="auto" outlined>
              <v-card-text>
                <v-row dense>
                  <v-col v-if="showMovs" cols="12">
                    <ViewMovementsField :itemAction="movs" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
      </v-tabs-items>
    </v-card>
  </template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import ViewMovementsField from '@/components/fields/specific/ViewMovementsField'
export default {
  props: ['model'],
  data: () => ({
    tab: 0,
    movs: {
      field: 'showMovsDataServer',
      name: '',
      nameid: 'movimientos',
      url: '/procesos/movimientos',
      default: '/procesos/movimientos',
      hidden: true,
      cols: 12
    },
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'seguimiento.solicitudes.create' }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Descripcion', value: 'caracteristicas.descripcion', class: 'black--text' },
          { text: 'Marca - Modelo', value: 'MarcaModelo', class: 'black--text' },
          { text: 'Serie', value: 'especificaciones.serie', class: 'black--text' }
        ],
        loading: false,
        filter: true
      },
      body: {
        data: [],
        actions: [
          { title: 'Reporte de Alta', icon: 'mdi-file-pdf-box', color: 'amber darken-2', action: 'DownloadPdfData', code: 'libre', hidden: '' }
          // { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'updateData', code: 'inventariable.solicitudes_transferencia.entry' },
          // { title: 'Desc de Transferencia', icon: 'mdi-file-pdf-box', color: 'amber darken-2', action: 'DownloadPdfData', code: 'solicitudes.show.rpt' }
        ]
      },
      footer: {
        paging: true
      }
    },
    showMovs: false,
    showEq: false,
    itemInsumos: {}
  }),
  components: {
    ViewMovementsField,
    DataTableMain
  },
  methods: {
    ...mapMutations(['SHOW_DIALOG_MAIN']),

    successAction (item) {
      this[item.action](item)
    },
    addInsumosView (item) {
      this.itemInsumos = {}
      this.itemInsumos = Object.assign({}, item.item)
      this.SHOW_DIALOG_MAIN({ type: 'addInsumos', with: 900, title: 'Agregar Insumos' })
    },
    returnedInsumosView (item) {},
    viewMovs (folio) {
      this.showMovs = false
      this.movs.url = `${this.movs.default}?folio=${folio}&mov=all`
      setTimeout(() => { this.showMovs = true }, 200)
    },
    viewEquipo () {
    /*
        if (this.model.descripcion.equipo) return
        this.showEq = false
        const router = this.get_urls['catalogo.familias-caracteristica.formulario']
        this.urlGetServiceActionTwo({ url: router, params: `/${this.model.descripcion.inventario.caracteristicas.familia_id}`, replace: '/{id}' })
        setTimeout(() => { this.showEq = true }, 200)
    */
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain'])
  },
  watch: {
    model (obj) {
      this.tab = 0
      this.table.body.data = []
      this.table.body.data = obj.inventarios
    }
  }
}
</script>
<style scoped>
.scroll-box {
  max-height: 250px;
  overflow-x: auto;
}
.scroll-box::-webkit-scrollbar {
  width: 18px;/* width of the entire scrollbar */
}

.scroll-box::-webkit-scrollbar-track {
  background: #d2d2d2;/* color of the tracking area */
  border-radius: 20px;
}
.scroll-box::-webkit-scrollbar-thumb {
  background-color: #3F51B5;  /* color of the scroll thumb */
  border-radius: 10px;       /* roundness of the scroll thumb */
  border: -7px solid #d2d2d2;/* creates padding around scroll thumb */
}
.cuadro{
  padding-left: 40px;
  padding-right: 40px;
  margin-top: 10px;
  margin-bottom: 15px;
}
.cuadro2{
  padding-left: 44px;
  padding-right: 30px;
}
</style>
